var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "d-flex mb-1" }, [
        _c(
          "div",
          { staticClass: "font-large-1  d-inline-block pr-1 text-bold-700" },
          [_vm._v(" " + _vm._s(_vm.__("event.title")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              " w-25 border-left-light pl-1 font-small-3  d-none d-md-inline-block",
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.__("event.search.heading")) +
                "\n        "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.top_events.length > 0
        ? _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "font-medium-4 text-primary d-inline-block py-1 text-bold-700",
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.__("event.title_popular")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row match-height pl-05 pr-05" },
              [
                _vm._l(_vm.top_events, function (event, index) {
                  return [
                    _c("guest-event-card", {
                      key: _vm.infiniteId + index,
                      attrs: {
                        event: event,
                        service_settings: _vm.service_settings,
                      },
                    }),
                  ]
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("search", {
        attrs: {
          filters: _vm.filters,
          categories: _vm.categories,
          types: _vm.types,
          guest: true,
        },
        on: {
          searchType: function ($event) {
            return _vm.changeFilter($event)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row match-height pl-05 pr-05" },
        [
          _vm._l(_vm.events, function (event, index) {
            return [
              event.event_type === "event"
                ? _c("guest-event-card", {
                    key: _vm.infiniteId + index * 1000,
                    attrs: {
                      event: event,
                      service_settings: _vm.service_settings,
                    },
                  })
                : event.event_type === "zoom"
                ? _c("guest-zoom-meeting-card", {
                    key: _vm.infiniteId + index * 2000,
                    attrs: {
                      zoom_meeting: event,
                      service_settings: _vm.service_settings,
                    },
                  })
                : event.event_type === "webinar"
                ? _c("guest-zoom-webinar-card", {
                    key: _vm.infiniteId + index * 3000,
                    attrs: {
                      zoom_webinar: event,
                      service_settings: _vm.service_settings,
                    },
                  })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "infinite-loading",
        {
          attrs: { identifier: _vm.infiniteId },
          on: {
            distance: function ($event) {
              1
            },
            infinite: _vm.infiniteHandler,
          },
        },
        [
          _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "no-results" }, slot: "no-results" }, [
            _vm._v(" " + _vm._s(_vm.__("globals.no_events_found"))),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }